import { render, staticRenderFns } from "./DialogPetitionDetail.vue?vue&type=template&id=0b539133&"
import script from "./DialogPetitionDetail.vue?vue&type=script&lang=js&"
export * from "./DialogPetitionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports